import { DisplayItem, RewardType } from "components/DIP/types";
import { useAppSelector } from "hooks";
import { useEffect, useState } from "react";
import { selectWebStoreState } from "redux/slices";
import { isEqual } from "lodash";

const useRewardsById = (rewardId: string): DisplayItem["rewards"] => {
	const store = useAppSelector(selectWebStoreState).store;
	const rewards = store?.rewards ?? {};
	const rewardTypes = store?.rewardTypes ?? [];
	const [displayRewards, setDisplayRewards] = useState<DisplayItem["rewards"]>(
		[]
	);

	useEffect(() => {
		const items = rewards[rewardId]?.items || {};

		const newDisplayRewards: DisplayItem["rewards"] = [];
		Object.entries(items).forEach(([rewardItemId, units]) => {
			const rewardType: RewardType | undefined = rewardTypes.find(
				(type: RewardType) => type.id === rewardItemId
			);
			if (rewardType) {
				const { imageUrl, overrideImageUrl, pluralLabel, singularLabel } =
					rewardType;
				newDisplayRewards.push({
					id: rewardItemId,
					imageUrl,
					overrideImageUrl,
					description: units.toLocaleString("en-US"),
					singularLabel,
					pluralLabel
				});
			}
		});

		const chestId = rewards[rewardId]?.chestId || "";

		if (chestId) {
			newDisplayRewards.push({
				id: chestId,
				imageUrl: "",
				overrideImageUrl: rewards[rewardId]?.overrideImageUrl,
				description: "",
				singularLabel: "Chest",
				pluralLabel: ""
			});
		}

		setDisplayRewards((v) =>
			isEqual(v, newDisplayRewards) ? v : newDisplayRewards
		);
	}, [rewardId, rewards, rewardTypes]);

	return displayRewards;
};

export default useRewardsById;
